import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer data-testid="main-footer" className="bg-navy text-white py-16">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          <div className="col-span-1">
            <div className="flex items-center space-x-2 mb-4">
              <img
                src="/logo.webp"
                alt="VibhumEduSys logo"
                className="h-10 w-10 rounded-lg object-cover"
              />
              <span className="text-xl font-heading font-bold">VibhumEduSys</span>
            </div>
            <p className="text-slate-300 text-sm leading-relaxed">
              Modern school management software trusted by leading educational
              institutions across India.
            </p>
          </div>

          <div>
            <h3 className="font-heading font-semibold text-lg mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/services/features"
                  data-testid="footer-link-features"
                  className="text-slate-300 hover:text-emerald transition-colors text-sm"
                >
                  Features
                </Link>
              </li>
              <li>
                <Link
                  to="/services/ai-chatbot"
                  data-testid="footer-link-ai-chatbot"
                  className="text-slate-300 hover:text-emerald transition-colors text-sm"
                >
                  AI Chatbot
                </Link>
              </li>
              <li>
                <Link
                  to="/pricing"
                  data-testid="footer-link-pricing"
                  className="text-slate-300 hover:text-emerald transition-colors text-sm"
                >
                  Pricing
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  data-testid="footer-link-about"
                  className="text-slate-300 hover:text-emerald transition-colors text-sm"
                >
                  About Us
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  data-testid="footer-link-contact"
                  className="text-slate-300 hover:text-emerald transition-colors text-sm"
                >
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-heading font-semibold text-lg mb-4">Resources</h3>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/register"
                  data-testid="footer-link-demo"
                  className="text-slate-300 hover:text-emerald transition-colors text-sm"
                >
                  Get Started Free
                </Link>
              </li>
              <li>
                <Link
                  to="/privacy"
                  data-testid="footer-link-privacy"
                  className="text-slate-300 hover:text-emerald transition-colors text-sm"
                >
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link
                  to="/terms-and-condition"
                  data-testid="footer-link-terms"
                  className="text-slate-300 hover:text-emerald transition-colors text-sm"
                >
                  Terms and Conditions
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-heading font-semibold text-lg mb-4">Contact</h3>
            <ul className="space-y-3">
              <li className="flex items-center space-x-2 text-sm text-slate-300">
                <Phone className="h-4 w-4 text-emerald" />
                <span>+91 96256 90427</span>
              </li>
              <li className="flex items-center space-x-2 text-sm text-slate-300">
                <Mail className="h-4 w-4 text-emerald" />
                <span>vibhumedusys@gmail.com</span>
              </li>
              <li className="flex items-start space-x-2 text-sm text-slate-300">
                <MapPin className="h-4 w-4 text-emerald mt-1" />
                <span>Rohini sector 21, New Delhi, India</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-700 mt-12 pt-8 text-center text-sm text-slate-400">
          <p>&copy; {currentYear} VibhumEduSys. All rights reserved.</p>
          <div className="mt-3 flex flex-wrap items-center justify-center gap-x-4 gap-y-2">
            <Link
              to="/privacy"
              data-testid="footer-bottom-privacy"
              className="hover:text-emerald transition-colors"
            >
              Privacy
            </Link>
            <span className="text-slate-600" aria-hidden="true">
              |
            </span>
            <Link
              to="/terms-and-condition"
              data-testid="footer-bottom-terms"
              className="hover:text-emerald transition-colors"
            >
              Terms and Conditions
            </Link>
          </div>
          <div className="mt-3 inline-flex items-center justify-center gap-2 text-slate-300">
            <span>Powered by Virtual Prachar</span>
            <a
              href="https://virtualprachar.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center hover:opacity-90 transition-opacity"
              data-testid="footer-powered-by-link"
              aria-label="Virtual Prachar"
            >
            <img
              src="/virtualpracha_logo.png"
              alt="Virtual Prachar logo"
              className="h-6 w-6 rounded-full object-contain"
            />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
